import { __generator } from "tslib";
import { call, select, delay } from 'redux-saga/effects';
import get from 'lodash/get';
import { getGallectionById } from '../selectors';
import { request } from '../../xhr';
import { getGallectionType } from '../helpers';
function setGallectionDescription(action) {
    var _a, folderId, description, gallection, params;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, delay(500)];
            case 1:
                _c.sent(); // + takeLatest = debounced
                _a = action.payload, folderId = _a.folderId, description = _a.description;
                return [4 /*yield*/, select(getGallectionById, folderId)];
            case 2:
                gallection = _c.sent();
                if (!gallection) {
                    return [2 /*return*/];
                }
                params = {
                    type: (_b = getGallectionType(gallection)) !== null && _b !== void 0 ? _b : 'collection',
                    folderid: gallection.folderId,
                    name: gallection.name,
                    description: description,
                    cover_deviationid: gallection.type === 'stash'
                        ? undefined
                        : get(gallection, 'thumb.deviationId'),
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/update',
                        data: params,
                    })];
            case 3:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default setGallectionDescription;
//# sourceMappingURL=saveChangedGallectionDescription.js.map